/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { subscriptionChangeTrialPlan } from '../../axios/subscriptionChangeTrialPlan'
import type {
	SubscriptionChangeTrialPlanError,
	SubscriptionChangeTrialPlanPathParams,
	SubscriptionChangeTrialPlanRequest,
	SubscriptionChangeTrialPlanResponse,
} from '../../types/SubscriptionChangeTrialPlan'

export const subscriptionChangeTrialPlanMutationKey = () =>
	[{ url: '/:organisation/profiles/:profile/trial/plan' }] as const

export type SubscriptionChangeTrialPlanMutationKey = ReturnType<typeof subscriptionChangeTrialPlanMutationKey>

export type SubscriptionChangeTrialPlanVariables = {
	organisation: SubscriptionChangeTrialPlanPathParams['organisation']
	profile: SubscriptionChangeTrialPlanPathParams['profile']
	data: SubscriptionChangeTrialPlanRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/SubscriptionController.php SubscriptionController::changeTrialPlan */
export function useSubscriptionChangeTrialPlan<TContext = unknown>(
	options?: UseMutationOptions<
		SubscriptionChangeTrialPlanResponse,
		AxiosError<SubscriptionChangeTrialPlanError>,
		SubscriptionChangeTrialPlanVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: subscriptionChangeTrialPlanMutationKey(),
		mutationFn: ({ organisation, profile, data }: SubscriptionChangeTrialPlanVariables) =>
			subscriptionChangeTrialPlan(organisation, profile, data, config).then(res => res.data),
		...options,
	})
}
